import script from "./heading-box.vue?vue&type=script&setup=true&lang=ts"
export * from "./heading-box.vue?vue&type=script&setup=true&lang=ts"

import "./heading-box.vue?vue&type=style&index=0&id=03f5083c&lang=scss"

const __exports__ = script;

export default __exports__